"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEntity = exports.Entity = void 0;
class Entity {
    id = null;
    attributes = null;
    references = {};
    constructor(id, attributes) {
        this.id = id;
        this.attributes = attributes;
    }
}
exports.Entity = Entity;
const createEntity = (constructor, id, attributes) => new constructor(id, attributes);
exports.createEntity = createEntity;
//# sourceMappingURL=useStore.entities.js.map